export const analyNameExceptions = {
  SEM: { camel: 'SEM', kebab: 'SEM' },
  TTestIndependent: { camel: 'tTestIndependent', kebab: 't-test-independent' },
  TTestDependent: { camel: 'tTestDependent', kebab: 't-test-dependent' },
}

export function getAnalyCamel(analysisName) {
  if (analysisName in analyNameExceptions)
    return analyNameExceptions[analysisName].camel

  return toCamelCase(toKebabCase(analysisName))
}

export function getAnalyKebab(analysisName) {
  if (analysisName in analyNameExceptions)
    return analyNameExceptions[analysisName].kebab

  return toKebabCase(analysisName)
}

export function toCamelCase(str) {
  return str.toLowerCase().replace(/[-_](.)/g, (_, char) => char.toUpperCase()) // - 또는 _ 뒤 문자를 대문자로 변환
}

export function toKebabCase(str) {
  return str.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase() // 소문자와 대문자 사이에 하이픈 삽입
}
